(() => {
  'use strict';
  const storageKey = 'mrparquet.interiorismo.favorites.v1';
  const root = document;
  let saved = [];
  let activeGallery = [];
  let galleryIndex = 0;
  let toastTimer;
  const q = (selector) => root.querySelector(selector);
  const qa = (selector) => [...root.querySelectorAll(selector)];

  function safeProductURL(value) {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^\/products\/[a-z0-9-]+$/.test(url.pathname)) return null;
      const variant = url.searchParams.get('variant') || '';
      return url.pathname + (/^[1-9]\d{0,19}$/.test(variant) ? '?variant=' + variant : '');
    } catch { return null; }
  }
  function safeImageURL(value) {
    try {
      const url = new URL(value, location.origin);
      return (url.protocol === 'https:' && ['cdn.shopify.com', 'mrparquet.com.uy'].includes(url.hostname)) ||
        (url.origin === location.origin && url.pathname.startsWith('/assets/')) ? url.href : '';
    } catch { return ''; }
  }
  try {
    const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(stored)) saved = stored.filter(item => item && typeof item.id === 'string' && typeof item.title === 'string' && safeProductURL(item.url)).slice(0, 100).map(item => ({ ...item, url: safeProductURL(item.url) }));
  } catch { /* Private browsing or unavailable storage still allows this session's selection. */ }

  function announce(message) {
    const toast = q('[data-toast]');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
  }
  function renderSaved() {
    qa('[data-saved-count]').forEach(counter => { counter.textContent = String(saved.length); counter.hidden = !saved.length; });
    qa('[data-save]').forEach(button => {
      const selected = saved.some(item => item.id === button.dataset.save);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', `${selected ? 'Quitar de favoritos' : 'Guardar'} ${button.dataset.title}`);
    });
    const list = q('[data-saved-list]');
    if (!list) return;
    list.replaceChildren();
    if (!saved.length) {
      const empty = document.createElement('p');
      empty.className = 'at-saved-empty';
      empty.textContent = 'Tu próximo espacio empieza con algo que te gusta. Tocá el corazón de un material para guardarlo acá.';
      const link = document.createElement('a');
      link.href = '/collections/pisos-de-madera';
      link.textContent = 'Explorar los materiales →';
      empty.append(link); list.append(empty);
      return;
    }
    saved.forEach(item => {
      const row = document.createElement('div'); row.className = 'at-saved-item';
      const imageURL = safeImageURL(item.image);
      if (imageURL) {
        const img = document.createElement('img'); img.src = imageURL; img.alt = ''; img.width = 82; img.height = 95;
        row.append(img);
      }
      const link = document.createElement('a'); link.href = safeProductURL(item.url); link.textContent = item.title;
      const remove = document.createElement('button'); remove.type = 'button'; remove.className = 'at-icon-button';
      remove.textContent = '×'; remove.dataset.removeSaved = item.id; remove.setAttribute('aria-label', `Quitar ${item.title}`);
      row.append(link, remove); list.append(row);
    });
  }
  function persist() {
    try { localStorage.setItem(storageKey, JSON.stringify(saved)); }
    catch { announce('Selección guardada para esta visita. El navegador no permite guardarla entre visitas.'); }
    renderSaved();
  }
  function openDialog(selector) {
    const dialog = q(selector);
    if (!dialog || typeof dialog.showModal !== 'function') return;
    qa('dialog[open]').forEach(other => other.close());
    qa('.at-nav details[open]').forEach(details => { details.open = false; });
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  }
  function renderGallery() {
    const item = activeGallery[galleryIndex];
    if (!item) return;
    const image = q('[data-lightbox-image]');
    image.src = item.href;
    image.alt = item.querySelector('img')?.alt || item.dataset.caption || '';
    q('[data-lightbox-caption]').textContent = item.dataset.caption || image.alt;
    q('[data-lightbox-counter]').textContent = `${String(galleryIndex + 1).padStart(2, '0')} / ${String(activeGallery.length).padStart(2, '0')}`;
    q('[data-lightbox-prev]').hidden = activeGallery.length < 2;
    q('[data-lightbox-next]').hidden = activeGallery.length < 2;
  }
  function stepGallery(direction) {
    galleryIndex = (galleryIndex + direction + activeGallery.length) % activeGallery.length;
    renderGallery();
  }
  root.addEventListener('click', event => {
    const target = event.target.closest('button, a');
    if (!target) return;
    if (target.matches('[data-open-saved]')) { renderSaved(); openDialog('[data-saved-dialog]'); }
    if (target.matches('[data-open-search]')) { openDialog('[data-search-dialog]'); q('#at-query')?.focus(); }
    if (target.matches('[data-open-menu]')) openDialog('[data-menu-dialog]');
    if (target.matches('[data-close-dialog]')) target.closest('dialog')?.close();
    if (target.matches('[data-save]')) {
      const index = saved.findIndex(item => item.id === target.dataset.save);
      if (index >= 0) { saved.splice(index, 1); announce('Material quitado de tu selección.'); }
      else {
        const url = safeProductURL(target.dataset.url);
        if (!url) return;
        if (saved.length >= 100) { announce('Tu selección ya tiene 100 materiales. Quitá uno para agregar otro.'); return; }
        saved.push({ id: target.dataset.save, title: target.dataset.title, image: safeImageURL(target.dataset.image), url });
        announce('Material guardado en tus favoritos.');
      }
      persist();
    }
    if (target.matches('[data-remove-saved]')) {
      saved = saved.filter(item => item.id !== target.dataset.removeSaved);
      persist();
      const nextControl = q('[data-saved-dialog] [data-remove-saved]') || q('[data-saved-dialog] [data-close-dialog]');
      nextControl?.focus();
    }
    if (target.matches('[data-look-button]')) {
      const look = target.closest('[data-look]');
      look.querySelectorAll('[data-look-button]').forEach(button => button.setAttribute('aria-pressed', String(button === target)));
      look.querySelectorAll('[data-look-panel]').forEach(panel => { panel.hidden = panel.id !== target.getAttribute('aria-controls'); });
    }
    if (target.matches('[data-gallery]')) {
      event.preventDefault();
      activeGallery = qa('[data-gallery]').filter(item => item.dataset.gallery === target.dataset.gallery);
      if (target.matches('[data-product-main]') && qa('[data-gallery="product-details"]').length) {
        activeGallery = qa('[data-gallery="product-details"]');
      }
      galleryIndex = Math.max(0, activeGallery.findIndex(item => item.href === target.href));
      renderGallery(); openDialog('[data-lightbox]');
    }
    if (target.matches('[data-lightbox-prev]')) stepGallery(-1);
    if (target.matches('[data-lightbox-next]')) stepGallery(1);
    if (target.matches('[data-product-thumb]')) {
      event.preventDefault();
      const main = q('[data-product-main]');
      const mainImage = main?.querySelector('img');
      if (!mainImage) return;
      mainImage.src = target.href;
      mainImage.removeAttribute('srcset');
      mainImage.alt = target.querySelector('img')?.alt || '';
      main.href = target.href;
      qa('[data-product-thumb]').forEach(thumb => thumb.setAttribute('aria-current', String(thumb === target)));
    }
    if (target.closest('[data-menu-dialog]') && target.tagName === 'A') target.closest('dialog').close();
  });
  root.addEventListener('keydown', event => {
    if (q('[data-lightbox]')?.open && activeGallery.length) {
      if (event.key === 'ArrowRight') { event.preventDefault(); stepGallery(1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); stepGallery(-1); }
    }
    if (event.key === 'Escape') qa('.at-nav details[open]').forEach(details => { details.open = false; details.querySelector('summary')?.focus(); });
  });
  root.addEventListener('click', event => {
    qa('.at-nav details[open]').forEach(details => { if (!details.contains(event.target)) details.open = false; });
  });
  qa('dialog').forEach(dialog => {
    dialog.addEventListener('close', () => { if (!q('dialog[open]')) document.documentElement.style.overflow = ''; });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
  });
  const vendorSelect = q('[data-vendor-filter]');
  if (vendorSelect) {
    // The server filters the full collection; its rendered selection also wins over Back/Forward form restoration.
    const restoreVendor = () => {
      vendorSelect.value = [...vendorSelect.options].find(option => option.defaultSelected)?.value || '';
    };
    restoreVendor();
    window.addEventListener('pageshow', restoreVendor);
    vendorSelect.addEventListener('change', () => {
      const url = new URL(location.href);
      url.searchParams.delete('page');
      url.searchParams.delete('view');
      url.searchParams.delete(vendorSelect.name);
      if (vendorSelect.value) url.searchParams.set(vendorSelect.name, vendorSelect.value);
      location.assign(url.href);
    });
  }
  window.addEventListener('storage', event => {
    if (event.key !== storageKey) return;
    try { const next = JSON.parse(event.newValue || '[]'); if (Array.isArray(next)) saved = next.filter(item => item && typeof item.id === 'string' && typeof item.title === 'string' && safeProductURL(item.url)).slice(0, 100).map(item => ({ ...item, url: safeProductURL(item.url) })); renderSaved(); } catch { /* Ignore malformed browser storage. */ }
  });
  root.addEventListener('shopify:section:load', renderSaved);
  root.addEventListener('change', event => {
    if (!event.target.matches('[data-at-variant-select]')) return;
    const wrapper = event.target.closest('.product-form-wrapper');
    const input = wrapper?.querySelector('[data-at-variant-id]');
    if (input) input.value = event.target.value;
    const url = new URL(location.href);
    url.searchParams.delete('view');
    url.searchParams.set('variant', event.target.value);
    // Let Shopify refresh availability, quote controls and the selected variant image together.
    location.assign(url.href);
  });
  document.body.classList.add('is-interactive');
  renderSaved();
})();
